<template>
  <div class="homepage_content">
    <Row type="flex" justify="space-between" align="top">
      <!-- 快捷模块 -->
      <Col :sm="24" :md="24" :lg="16" :xl="16">
        <div class="home_fastmodule">
          <ul>
            <li v-for="(item, index) in fastmodule" :key="index">
              <router-link :to="item.link">
                <i class="icon iconfont" :class="item.icon"></i>
                <span>{{item.name}}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </Col>
      <!-- 余额 -->
      <Col :sm="24" :md="24" :lg="8" :xl="8">
        <div class="homepage_balance_content">
          <h3>预存款余额(元)</h3>
          <span>{{balance}}</span>
          <a href="javascript:;" @click="payClick">立即充值</a>
        </div>
      </Col>
      <!-- 我的订单 -->
      <Col :sm="24" :md="24" :lg="16" :xl="16" class="homepage_mt_negative82">
        <div class="homepage_module_content">
          <div class="homepage_module_head">
            <div class="homepage_module_head_left"><h3>我的订单</h3></div>
            <div class="homepage_module_head_right">
              <router-link to="/Order">全部订单<i class="icon iconfont icon-icon_zhankai_xiangxia1"></i></router-link>
            </div>
          </div>
          <div class="homepage_order_content">
            <ul>
              <li v-for="(item, index) in ordercount" :key="index">
                <b @click="gotoorderlist(item.value)">{{item.allnum}}</b>
                <span>{{index == 'nopayinfo' ? '待付款' : (index == 'status2info' ? '待发货' : (index == 'status3info' ? '待收货' : (index == 'rebackinfo' ? '待退货' : '')))}}</span>
              </li>
            </ul>
          </div>
        </div>
      </Col>
      <!-- 通知公告 -->
      <Col :sm="24" :md="24" :lg="8" :xl="8">
        <div class="homepage_module_content mr0">
          <div class="homepage_module_head">
            <div class="homepage_module_head_left"><h3>通知公告</h3></div>
            <div class="homepage_module_head_right">
              <router-link to="/News">更多<i class="icon iconfont icon-icon_zhankai_xiangxia1"></i></router-link>
            </div>
          </div>
          <div class="homepage_noticelist_content homepage_h202" v-if="notice.length != 0">
            <ul>
              <li v-for="(item, index) in notice" :key="index" @click="listClick(item.id)" v-if="index < 5">
                <span>{{item.title}}</span>
                <small>{{item.addtime2}}</small>
              </li>
            </ul>
          </div>
          <div class="homepage_no homepage_h202" v-else>暂无信息~</div>
        </div>
      </Col>
      <!-- 业务消息 -->
      <Col :sm="24" :md="24" :lg="16" :xl="16" class="homepage_mt_negative164">
        <div class="homepage_module_content">
          <div class="homepage_module_head">
            <div class="homepage_module_head_left"><h3>业务消息</h3></div>
            <div class="homepage_module_head_right">
              <router-link to="/Notice">更多<i class="icon iconfont icon-icon_zhankai_xiangxia1"></i></router-link>
            </div>
          </div>
          <div class="homepage_newslist_content homepage_h350" v-if="news.length != 0">
            <ul>
              <li v-for="(item, index) in news" :key="index" @click="noticeClick(item)" v-if="index < 7">
                <span>{{item.content}}</span>
                <small>{{item.addtime}}</small>
              </li>
            </ul>
          </div>
          <div class="homepage_no homepage_h350" v-else>暂无信息~</div>
        </div>
      </Col>
      <!-- 手机扫码订货 -->
      <Col :sm="24" :md="24" :lg="8" :xl="8">
        <div class="homepage_module_content mr0">
          <div class="homepage_module_head">
            <div class="homepage_module_head_left"><h3>手机扫码订货</h3></div>
            <div class="homepage_module_head_right"></div>
          </div>
          <div class="homepage_qrcode_content">
            <ul>
              <li v-for="(item, index) in qrcode" :key="index">
                <img :src="item.img" />
                <span>{{item.title}}</span>
              </li>
            </ul>
          </div>
        </div>
      </Col>
    </Row>
    <noLoginTips :nologinShow="nologinShow" :nologintipsmsg="nologintipsmsg" @nologinOk="nologinOk" @nologinCancel="nologinCancel"></noLoginTips>
  </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
import {formatDate} from '@/filter/dateFilter.js'
import noLoginTips from '@/components/component/popup/nologintips.vue'

export default {
  name: 'home',
  components: {noLoginTips},
  data() {
    return {
      balance: 0, // 余额
      fastmodule: [ // 快捷模块
        {
          'icon': 'icon-lijixiadan',
          'name': '立即下单',
          'link': '/Goods/0'
        },
        {
          'icon': 'icon-kuaisubuhuo',
          'name': '快速补货',
          'link': '/Replenish'
        },
        {
          'icon': 'icon-xinpinshangjia',
          'name': '新品上架',
          'link': '/Goods/1'
        },
        {
          'icon': 'icon-shangpincuxiao',
          'name': '商品促销',
          'link': '/Promotion'
        },
        {
          'icon': 'icon-shangpinshoucang',
          'name': '商品收藏',
          'link': '/Collection'
        }
      ],
      ordercount: { // 我的订单
        nopayinfo: {allnum: '--'},
        status2info: {allnum: '--'},
        status3info: {allnum: '--'},
        rebackinfo: {allnum: '--'},
      },
      notice: [], // 通知公告
      news: [], // 业务消息
      qrcode: [ // 手机扫码订货
        {
          img: '',
          title: 'APP下载'
        },
        {
          img: '',
          title: '微信小程序订货'
        }
      ],
      nologinShow: false, // 未登录弹窗是否显示
      nologintipsmsg: false, // 未登录弹窗信息
    }
  },
  methods: {
    getInfo () { // 获取数据
      this.http.post(api.home)
      .then(response => {
        console.log(response.data)
        for (var i = 0; i < response.data.msg.qrcodelist.length; i++) {
          this.qrcode[i].img = response.data.msg.qrcodelist[i]
        }
        if (!this.$store.state.openmall) {
          this.balance = response.data.msg.customerone.cost
          this.ordercount.nopayinfo = response.data.msg.ordertj.nopayinfo
          this.ordercount.status2info = response.data.msg.ordertj.status2info
          this.ordercount.status3info = response.data.msg.ordertj.status3info
          this.ordercount.rebackinfo = response.data.msg.ordertj.rebackinfo
          this.notice = response.data.msg.datalist
          this.news = response.data.msg.orderloglist
        }
      })
      .catch(error => {
        console.log(error);
      })
    },
    gotoorderlist (value) { // 点击跳转订单列表
      let link = ''
      value != undefined ? link = '订货单' : link = '退货单'
      this.$router.push({
        name: link,
        params: {
          statetype: value != undefined ? value : '2'
        }
      })
    },
    listClick (id) { // 点击列表
      this.$router.push({
        name: '公司通知公告详情',
        params: {
          id: id
        }
      })
    },
    noticeClick (item) { // 点击列表
      if (item.type == 1) { // 1 订货单详情  2 退货单详情  3 预存款账户
          this.$router.push({
              name: '订货详情',
              params: {
                  id: item.orderid
              }
          })
      } else if (item.type == 2) {
          this.$router.push({
              name: '退货单订单详情',
              params: {
                  id: item.orderid
              }
          })

      } else if (item.type == 3) {
          this.$router.push('/DepositRecord')
          
      }
    },
    payClick () {
      if (!this.$store.state.openmall) {
        this.$router.push({
          name: '支付',
          params: {
            type: 1,
            id: 0
          }
        })
      } else {
        this.nologintipsmsg = '未登录客户不可充值，请登录'
        this.nologinShow = true
      }
    },
    nologinOk () {
      this.nologinShow = false
    },
    nologinCancel () {
      this.nologinShow = false
    }
  },
  filters: {
    formatDate(time) {
      let date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
    }
  },
  created () {
    this.getInfo()
  }
}
</script>

<style scoped>

.homepage_content {
  padding: 0 20px 20px 20px;
}

.home_fastmodule {
  margin-top: 20px;
}

.home_fastmodule > ul {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.home_fastmodule > ul > li {
  width: 10px;
  height: 120px;
  flex-grow: 1;
  flex-shrink: 1;
  margin-right: 20px;
  display: flex;
  border-radius: 4px;
  background-position: center;
  background-size: cover;
}

.home_fastmodule > ul > li:last-child {
  margin-right: 0;
}

.home_fastmodule > ul > li:nth-child(1) {
  background-color: #e58e37;
  background-image: url(../../assets/images/fastmodule_bg1.png);
}

.home_fastmodule > ul > li:nth-child(2) {
  background-color: #29C7B0;
  background-image: url(../../assets/images/fastmodule_bg2.png);
}

.home_fastmodule > ul > li:nth-child(3) {
  background-color: #698ADF;
  background-image: url(../../assets/images/fastmodule_bg3.png);
}

.home_fastmodule > ul > li:nth-child(4) {
  background-color: #AD64CC;
  background-image: url(../../assets/images/fastmodule_bg4.png);
}

.home_fastmodule > ul > li:nth-child(5) {
  background-color: #F1CA5C;
  background-image: url(../../assets/images/fastmodule_bg5.png);
}

.home_fastmodule > ul > li > a {
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.home_fastmodule > ul > li > a > i {
  margin-top: 20px;
  font-size: 32px;
  color: #fff;
}

.home_fastmodule > ul > li > a > span {
  margin-top: 16px;
  font-size: 16px;
  color: #fff;
}

.homepage_balance_content {
  width: 100%;
  height: 202px;
  margin-top: 20px;
  background-color: #5B5FC2;
  background-image: url(../../assets/images/homepage_balance_bg.png);
  background-position: 80% 20%;
  background-repeat: no-repeat;
  border-radius: 4px;
  position: relative;
}

.homepage_balance_content > h3 {
  padding: 16px 0 0 15px;
  font-size: 16px;
  color: #fff;
}

.homepage_balance_content > span {
  padding: 15px 0 0 15px;
  font-size: 40px;
  color: #FFF3E1;
  display: block;
}

.homepage_balance_content > a {
  width: 68.6274%;
  height: 46px;
  line-height: 46px;
  text-align: center;
  font-size: 20px;
  color: #EACC9E;
  font-weight: bold;
  border-radius: 20px 20px 0 0;
  background-color: #000;
  transform: translateX(-50%);
  position: absolute;
  bottom: 0;
  left: 50%;
  z-index: 1;
}

.homepage_module_head_right > a {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.homepage_module_head_right > a > i {
  color: #666;
  transition: all .2s;
}

.homepage_module_head_right > a:hover > i {
  color: #FF8000;
}

.homepage_order_content {
  height: 120px;
}

.homepage_order_content > ul {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.homepage_order_content > ul > li {
  width: 10px;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.homepage_order_content > ul > li > b {
  font-size: 30px;
  color: #FF8000;
  cursor: pointer;
}

.homepage_order_content > ul > li > span {
  margin-top: 4px;
  font-size: 16px;
  color: #666;
}

.homepage_noticelist_content > ul > li,
.homepage_newslist_content > ul > li {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.homepage_noticelist_content > ul > li > span,
.homepage_newslist_content > ul > li > span {
  max-width: 70%;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.homepage_noticelist_content > ul > li > small,
.homepage_newslist_content > ul > li > small {
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 14px;
  color: #999;
}

.homepage_noticelist_content > ul {
  padding: 0 20px;
}

.homepage_noticelist_content > ul > li {
  height: 40px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
}

.homepage_noticelist_content > ul > li:last-child {
  border-bottom: none;
}

.homepage_newslist_content > ul > li {
  height: 50px;
  padding: 0 20px;
  cursor: pointer;
}

.homepage_newslist_content > ul > li:nth-child(even) {
  background-color: #FAFBFD;
}

.homepage_no {
  min-height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #999;
}

.homepage_qrcode_content > ul {
  height: 186px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.homepage_qrcode_content > ul > li {
  width: 10px;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.homepage_qrcode_content > ul > li > img {
  width: 90px;
  height: 90px;
}

.homepage_qrcode_content > ul > li > span {
  margin-top: 12px;
  font-size: 16px;
  color: #333;
}

@media (min-width: 992px) {

  .home_fastmodule {
    margin-right: 20px;
  }
  
  .homepage_mt_negative82 {
    margin-top: -82px;
  }
  
  .homepage_mt_negative164 {
    margin-top: -164px;
  }

  .homepage_h202 {
    height: 202px;
  }

  .homepage_h350 {
    height: 350px;
  }

  .homepage_module_content {
    margin-right: 20px;
  }
  
}

</style>




// WEBPACK FOOTER //
// src/components/views/home.vue